export default __webpack_public_path__ + "static/media/work3.7fc5d33f.png";